<template>
  <div class="row mt-5">
    <PapelConsumo
      v-if="ordemServico.itens.length"
      ref="modalPapelConsumo"
      :prop-itens-os="ordemServico.itens"
      @updatePapeisSelecionados="updatePapeisSelecionados" />
    <div class="text-right">
      <CustomButton
        class="mr-3 pl-4 pr-4"
        text="Voltar"
        variant="light"
        @click="voltar()" />
      <CustomButton
        class="mr-3 pl-4 pr-4"
        :text="!!ordemServico.ordem_servico_id ? 'Salvar OS' : 'Cadastrar OS'"
        color="#074F7F"
        :disabled="propDisabled"
        color-text="white"
        @click="salvar()" />
    </div>
  </div>
</template>

<script>
  import { useCaseOrdemServico } from "@/entities/OrdemServico/useCaseOrdemServico"
  import { useCaseOrdemServicoItem } from "@/entities/OrdemServicoItem/useCaseOrdemServicoItem"
  import { UseCaseSelo } from "@/entities/Selo/UseCaseSelo"
  import { useCasePapelSegurancaLoteItem } from "@/entities/PapelSegurancaLoteItem/useCasePapelSegurancaLoteItem"

  // Components
  import PapelConsumo from "@/components/SofiaRei/PapelSeguranca/PapelConsumo"
  import CustomButton from "@/components/CustomButton/CustomButton"

  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'


  export default {
    name: "OrdensServicoFormSalvar",
    components: {
      PapelConsumo,
      CustomButton,
    },
    props: {
      propOrdemServico: {
        type: Object,
        default: () => {},
      },
      propDisabled: {
        type: Boolean,
        default: true,
      },
      propTipo: {
        type: String,
        default: ''
      },
      propRegistro: { type: Object, default: () => { return {} }},
      propData: { type: Object, default: null },
      propPedidoPendente: {type: Object, default: () => {}},
      propPedidoP13: {type: Object, default: () => {}},
    },
    data () {
      return {
        ordemServico: null,
      }
    },
    watch: {
      "propOrdemServico.itens" () {
        this.init()
      },
      "propPedidoPendente" () {
        this.init()
      },
      "propPedidoP13"(){
        this.init()
      },
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.ordemServico = this.propOrdemServico
      },
      async salvar () {
        const isUpdateOS = !!this.ordemServico.ordem_servico_id
        let OS = null
        let itensCriados = []
        let imprimirRecibo = false
        
        const consomePapel = this.ordemServico.itens.filter( (obj) => obj.impressosSeguranca === true && !obj.ordem_servico_item_id)

        // Abre modal de seleção de papel para consumo caso aplicavél
        if (!!consomePapel.length > 0) {
          const modalResult = await this.$refs.modalPapelConsumo.createModalPromise()
          if (!modalResult) return
        }

        try {
          loader({ text: "Salvando O.S. ...", active: true })

          OS = isUpdateOS ? await this.updateOs() : await new useCaseOrdemServico(this.ordemServico).create()


          for (let itemOs of this.ordemServico.itens) {
            // Caso seja um item já criado apenas atualizamos
            if (!!itemOs.ordem_servico_item_id) {
              await new useCaseOrdemServicoItem(itemOs).update()
              continue
            }

            const ordemServicoItem = await new useCaseOrdemServicoItem(itemOs).create(OS)
            if (ordemServicoItem) itensCriados.push(ordemServicoItem)

            itemOs = Object.assign(itemOs, ordemServicoItem)

            if (itemOs.seloStatus) {
              await new UseCaseSelo().create(OS, itemOs)
            }
          }
   

          if (this.propPedidoPendente) {
            this.$emit('solicitarImpressao')
          }

          if(this.propPedidoP13){
            this.$emit('solicitarImpressao')
          }
     
          // Redireciona e/ou recarrega a OS de acordo contexto
          if (isUpdateOS) {
            await this.propOrdemServico.reload()
            await this.__displayMenssage('success',"Sucesso", "Ordem de Serviço atualizada com Sucesso")
          } else if (this.propOrdemServico.registro_id) {
            await this.propOrdemServico.reload(OS.ordem_servico_id)
          }
          else {
            await this.$router.push(`/ordem-servico/${OS.ordem_servico_id}`) // *
            await this.__displayMenssage('success',"Sucesso", "Ordem de Serviço Criada com Sucesso")
          }

          // Impressão de recibo
          const questionImpressao = await displayQuestion('Imprimir Recibo', 'Deseja Imprimir o Recibo de Serviço ?', 'Sim', 'Não')
          const osCriada = await new useCaseOrdemServico().getById(OS.ordem_servico_id)
          
          if (questionImpressao) { 
            const url = await new useCaseOrdemServico(osCriada).imprimirRecibo(this.propTipo, this.propRegistro,this.propData)
            imprimirRecibo = questionImpressao
            // ** this.$emit('imprimirRecibo', url)

            /*  ⚠️ CUIDADO com eventos emitidos durante a navegação!
                1. O componente Pai atual está ouvindo eventos do Filho.
                2. Chamamos * "await this.$router.push(`/ordem-servico/${OS.ordem_servico_id}`)", iniciando a navegação para uma nova rota.
                3. O Vue destrói os componentes atuais (Pai e Filho).
                4. Se o Filho tentar emitir um evento nesse meio tempo ** "this.$emit('imprimirRecibo', url)", o Pai já não existe mais para ouvi-lo! 😵
                5. Vue monta os novos componentes da rota e o ciclo começa novamente.
                  
                ❌ Para evitar problemas, garanta que nenhum evento importante seja emitido durante a transição de rota.
                ✅ Como o "$emit" não funciona nesse cenário, foi necessário usar o Vuex para compartilhar os dados com o novo componente Pai que será renderizado após a navegação.
            */

            this.$store.dispatch('impressaoReciboOS/setPdfUrl', url)
          } else {
            this.$store.dispatch('impressaoReciboOS/setRecusarImpressaoReciboDeServico', true)
          }

        } catch (error) {
          const { message, data } = error
          await this.__displayMenssage('error','Erro', message)  
          await this.handlerErroCreateOS(isUpdateOS, OS, itensCriados, data.selos, data.papeisConsumidos)         
          window.location.reload()       
        } finally {
          loader({ text: "", active: false })

          // if (isUpdateOS && !imprimirRecibo) {
          //   window.location.reload()  
          // }

        }
      },
      async handlerErroCreateOS (isUpdateOS, OS, itensCriados, selosCriados, papeisConsumidos) {
        // Excluimos uma nova OS criada em caso de erro
        if (!isUpdateOS) {
          await new useCaseOrdemServico(OS).excluirPermanentemente()
          await this.$router.push(`/ordens-servicos`)
          // Os itens da os serão excluidos por CASCATA/AUTOMATICAMENTE
        }
        // Caso ocorra erro em uma OS já existente excluimos apenas os novos itens criados
        if (isUpdateOS) {
          for (const item of itensCriados) {
            await new useCaseOrdemServicoItem(item).delete()
          }
        }
        // Exclui possiveis selos criados em caso de erro
        if (selosCriados.length > 0) {
          for (const selo of selosCriados) {
            await new UseCaseSelo(selo).delete()
          }
        }
        // Cancelamos possiveis papeis utilizados em caso de erro
        if (papeisConsumidos.length > 0) {
          for (const papel of papeisConsumidos) {
            await new useCasePapelSegurancaLoteItem(papel).cancelarPapel()
          }
        }
      },
      async updateOs () {
        const { cpf_solicitante, nome_solicitante, data_cumprida } = this.ordemServico
        const oldOs = await new useCaseOrdemServico().getById(this.ordemServico.ordem_servico_id)
        // verifica se houve mudança no nome ou cpf do solicitante
        if (oldOs && (oldOs.cpf_solicitante !== cpf_solicitante) |
          (oldOs.nome_solicitante !== nome_solicitante) | (oldOs.data_cumprida.substring(0,10) !== data_cumprida)) {
          // Informa o usuario da retificação de selos
          const confirmacao = await displayQuestion(
            'Atenção!',
            'A ordem de serviço possue selos gerados e já enviados ao TJSP. Ao confirmar a alteração, será gerado um selo retificador e enviado ao TJSP para atualização das informações.'
          )
          if (!confirmacao) return false          
          
          await new useCaseOrdemServico(this.ordemServico).update()
        }

        if ((oldOs.itens.length !== this.ordemServico.itens.length) || (oldOs.valor_total !== this.ordemServico.valor_total)) {
          await new useCaseOrdemServico(this.ordemServico).update()
        }

        return this.ordemServico
      },
      updatePapeisSelecionados (itensComPapeis) {
        this.ordemServico.itens = itensComPapeis
      },
      voltar () {
        if (this.propOrdemServico.registro_id) {
          return this.$emit('onBack')
        }
        this.$router.push('/')
        this.$store.dispatch("procedimento/updateProcedimento", null)
        this.$store.dispatch("procedimento/updateRequerente", {})
      },
      async __displayMenssage (type,title, message) {
        await displayMessage(
          type,
          title, //type.charAt(0).toUpperCase() + type.slice(1),
          message
        )
      }
    },
  }
</script>

<style lang="scss" scoped>
// @import '@/scss/_utilities/_exports';

</style>
